<template>
    <b-badge
            pill
            variant="light"
            class="knowledge-asset-tag bg-gray-100"
    >
        <slot />
    </b-badge>
</template>

<script>
    import './Tag.scss';

    export default {
        name: "Tag"
    };
</script>
